import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Frame } from './Frame';
import { faqItems } from '../data/faq';
const ease = [0.23, 1, 0.32, 1] as const;
const cardShadow = 'shadow-[0_0_0_1px_rgba(70,28,64,0.07),0_1px_2px_rgba(70,28,64,0.04),0_10px_28px_-14px_rgba(70,28,64,0.1)]';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" aria-labelledby="faq-title" className="scroll-mt-[72px]" data-id="element-179" data-mp="2dy3gdfrztppo">
      <Frame data-id="element-180" data-mp="28za4frscu6rm">
        <div className="grid gap-10 px-5 py-16 md:grid-cols-[minmax(0,4fr)_minmax(0,7fr)] md:gap-12 md:px-6 md:py-24" data-id="element-181" data-mp="28zikfsjrxs71">
          <div data-id="element-182" data-mp="1z3fescpprbfc">
            <div className="md:sticky md:top-28" data-id="element-183" data-mp="1z3ym6zhqmhf4">
              <h2 id="faq-title" className="font-display text-[38px] font-semibold leading-[1.04] tracking-[-0.04em] text-ink md:text-[52px]" data-id="element-184" data-mp="1z59r52mx5v7t">
                Häufige Fragen.
              </h2>
              <p className="mt-5 max-w-[360px] text-[16px] leading-relaxed text-ink/70" data-id="element-185" data-mp="pheg9ufq6xbn">
                Formate, Software, Sicherheit und Preise. Alles andere – fragen Sie direkt.
              </p>
            </div>
          </div>

          <ul className="flex flex-col gap-2.5" data-id="element-186" data-mp="fj8hhlp7u7b0">
            {faqItems.map((item, i) => {
            const open = openIndex === i;
            const panelId = `faq-panel-${i}`;
            return <li key={item.question} className={`rounded-[10px] bg-white ${cardShadow}`} data-id="element-187" data-mp="6q57jnds4cl4" data-mpi={i}>
                  <h3 data-id="element-188" data-mp="bjq0v24fgidz">
                    <button type="button" aria-expanded={open} aria-controls={panelId} onClick={() => setOpenIndex(open ? null : i)} className="flex w-full items-center justify-between gap-6 rounded-[10px] px-5 py-[18px] text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink/30 md:px-6" data-id="element-189" data-mp="bjzqgolk8nj5">
                      <span className="text-[16px] font-medium text-ink md:text-[17px]" data-id="element-190" data-mp="1uhwa70anoqp6">{item.question}</span>
                      <span className={`grid h-7 w-7 shrink-0 place-items-center rounded-full transition-colors duration-150 ${open ? 'bg-ink text-white' : 'bg-canvas text-ink'}`} aria-hidden="true" data-id="element-191" data-mp="1ppclp8afkb5l">
                        <ChevronDownIcon className={`h-4 w-4 transition-transform duration-200 ease-out ${open ? 'rotate-180' : ''}`} data-id="element-192" data-mp="2dexfkm84gstn" />
                      </span>
                    </button>
                  </h3>
                  <AnimatePresence initial={false} data-id="element-193" data-mp="1zew5cg5yw91i">
                    {open && <motion.div id={panelId} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.22,
                  ease
                }} className="overflow-hidden" data-id="element-194" data-mp="s2vsae4tihp4">
                        <p className="max-w-[620px] px-5 pb-5 text-[15px] leading-relaxed text-muted md:px-6" data-id="element-195" data-mp="38oaitv40lcwi">{item.answer}</p>
                      </motion.div>}
                  </AnimatePresence>
                </li>;
          })}
          </ul>
        </div>
      </Frame>
    </section>;
}